import { parse, stringify } from 'hub-http/helpers/params';
export const parseQueryParams = queryString => {
  const queryParams = parse(queryString.replace('?', ''));
  return Object.fromEntries(Object.entries(queryParams).map(([key, value]) => {
    try {
      const parsed = Array.isArray(value) ? value.map(val => JSON.parse(val)) : JSON.parse(value);
      return [key, parsed];
    } catch (_unused) {
      return [key, value];
    }
  }));
};
export const getQueryParams = () => parseQueryParams(window.location.search);
export const stringifyQueryParams = queryParams => {
  Object.keys(queryParams).forEach(key => !queryParams[key] && delete queryParams[key]);
  return stringify(queryParams);
};
export const getRequestedProductAsQueryParams = requestedProducts => {
  if (!requestedProducts.length) {
    return {
      products: [],
      packs: []
    };
  }
  const tempProducts = [];
  const tempPacks = [];
  requestedProducts.forEach(({
    productApiName,
    quantityPackApiName,
    quantity
  }) => {
    if (quantityPackApiName) {
      tempPacks.push(`${quantityPackApiName}_${productApiName}_${quantity || 1}`);
    } else {
      tempProducts.push(`${productApiName}_${quantity || 1}`);
    }
  });
  return {
    products: tempProducts,
    packs: tempPacks
  };
};